import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { selectAuthUser } from '../../redux/auth/auth.selectors';

import './OnboardingBackToApp.scss';

// "Back to app" control for the invitation page. Self-guards on currentUser
// (mirrors OnboardingUserMenu) so it never shows to signed-out visitors, who
// have no app to return to. Positioned top-left, just below the logo.
export const OnboardingBackToApp = () => {
    const history = useHistory();
    const currentUser = useSelector(selectAuthUser);

    if (!currentUser) return null;

    return (
        <div className="wo-back-wrap">
            <button className="wo-back" type="button" onClick={() => history.push('/diagrams/')}>
                {/* <svg
                    className="wo-back-icon"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                >
                    <path d="M19 12H5" />
                    <path d="M12 19l-7-7 7-7" />
                </svg> */}
                <svg className="wo-back-icon" width="14px" height="15px" fill="none" viewBox="0 -0.3 24 24" stroke="rgb(164, 175, 181)" strokeWidth="2px" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"></path></svg>
                <span>Back to app</span>
            </button>
        </div>
    );
};

export default OnboardingBackToApp;
